export default function authHeaders(USER_KEY) {
  const user =
    typeof localStorage.getItem(USER_KEY) != "undefined"
      ? JSON.parse(localStorage.getItem(USER_KEY))
      : "";

  if (user && user.auth_key) {
    return { Authorization: "Bearer " + user.auth_key }; // for Spring Boot back-end
    // return { 'x-access-token': user.accessToken };       // for Node.js Express back-end
  } else {
    return {};
  }
}
